import React, { useContext } from 'react'
import cloneDeep from 'lodash/cloneDeep'
import { RuleFormContext } from './formContext'
import { Row, Col } from 'uiComponents/flex'
import { TextArea } from 'uiComponents/input'
import { FormItem, FormItemName } from 'uiComponents/form/formElements'
import { Tabs } from 'uiComponents/navigation/tabs'
import { useTranslation } from 'translations'

function TranslationsSection() {
    const { t } = useTranslation()
    const { locales, formTranslations, rule, activeLangIndex, markErrors, updateTranslations, setActiveLangIndex } =
        useContext(RuleFormContext)

    const onTranslationChange = (value: string, lang: string) => {
        const updatedTranslations = cloneDeep(formTranslations)
        updatedTranslations.text[lang] = value
        updateTranslations(updatedTranslations)
    }

    const sameProduct = rule.rulePayload.productUuidPaid === rule.rulePayload.productUuidFree

    return (
        <Row>
            <Col span={5}>
                <FormItemName>{t('products.discountRules.form.translations')}</FormItemName>
                <Tabs
                    titles={locales.map((l) => l.name)}
                    setActive={setActiveLangIndex}
                    activeTabIndex={activeLangIndex}
                >
                    {locales.map((l) => {
                        const languageError = markErrors && !formTranslations.text[l.code]
                        return (
                            <div key={l.code}>
                                <FormItem htmlFor={`translations-${l.code}`}>
                                    <FormItemName>{t('products.discountRules.form.bannerText')}</FormItemName>
                                    <TextArea
                                        id="batch-note"
                                        value={formTranslations.text[l.code] || ''}
                                        placeholder={t('products.discountRules.form.bannerTextPlaceholder')}
                                        onChange={(e) => onTranslationChange(e.target.value, l.code)}
                                        maxLength={sameProduct ? 40 : 300}
                                        showCharsLeft
                                        status={languageError ? 'error' : 'normal'}
                                        block
                                    />
                                </FormItem>
                            </div>
                        )
                    })}
                </Tabs>
            </Col>
            <Col span={7} />
        </Row>
    )
}

export default TranslationsSection
